import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { JackingActivityEditor } from '../../../../models/projects/jacking-activity.models';
import { ValidationResult } from '../../../../models/projects/validation.models';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-jacking-activity-edit-complete',
  templateUrl: 'jacking-activity-edit-complete.html'
})
export class JackingActivityEditCompletePage {
  config = AppConfig.settings;

  loading: boolean;
  editor: JackingActivityEditor;
  validationResult: ValidationResult;
  callback: Function;
  notes: string;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.ionViewEnter();
  }

  async ionViewEnter() {
    this.editor = this.navParams.get('activity');
    this.validationResult = this.navParams.get('validation');
    this.callback = this.navParams.get('callback');
    this.loading = false;
  }

  async cancel() {
    this.callback(this.editor, true).then(() => {
      this.navCtrl.pop();
    });
  }

  async confirm() {
    this.editor.completionNotes = this.notes;
    this.callback(this.editor, false).then(() => {
      this.navCtrl.pop();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-edit-complete/jacking-activity-edit-complete.ts